export const PAGE_SIZE=5;export const PAGINATION_INIT_DATA={pageSize:PAGE_SIZE,pageNumber:1,totalCount:0,totalPages:0};